import React from 'react';

import BarcodeImage from 'assets/images/barcode.png';
import { ThemePropType } from 'assets/styles/theme';
import {
  ActionPortal,
  DefaultActionButtons,
} from 'components';

import { InvoiceWrapper } from './style';
import { Gray, Purple } from 'constants/colors';

export default function PaymentInvoice({
  theme, isValid, handleSubmit, onCancel, onSubmit,
}) {
  return (
    <InvoiceWrapper>
      <img
        src={BarcodeImage}
        alt="Boleto"
      />

      <ActionPortal>
        <DefaultActionButtons
          theme={theme}
          isValid={isValid}
          backButtonStyle={{
            iconPosition: 'left',
            border: 'none',
            customBackgroundColor: 'transparent',
            customIconColor: Gray[400],
            customTextColor: Gray[400],
            title: 'Passo Anterior',
          }}
          nextButtonStyle={{
            customBackgroundColor: Purple[500],
            customIconColor: Gray[100],
            customTextColor: Gray[100],
            title: 'Continuar',
          }}
          onCancel={onCancel}
          onSubmit={() => handleSubmit(onSubmit)()}
        />
      </ActionPortal>
    </InvoiceWrapper>
  );
}

PaymentInvoice.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  theme: ThemePropType.isRequired,
};
